import { RequiredAsterisk, Row } from "components/styles";
import { Label } from "./styles";

const LabelForm = ({
    text, required
}) => {
    return (
        <Row justifyContent="flex-start" gap="5px">
            <Label>{text}</Label>
            {required && <RequiredAsterisk>*</RequiredAsterisk>}
        </Row>
    );
}

export default LabelForm;